import {useState} from "react";

const DEFAULT_DATA_TABLE_PAGE_SIZE = 10;

const useDataTablePagination = (
  pageIndex = 0,
  pageSize = DEFAULT_DATA_TABLE_PAGE_SIZE,
) => {
  const [pagination, setPagination] = useState({
    pageIndex,
    pageSize,
  });

  return {
    pagination,
    setPagination,
  };
};

export default useDataTablePagination;
